import React, { Component } from 'react';

import Modal from "./Modal.js";
import ModalVentas from '../Ventas/Modal';

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable.js";
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";

import DateFilter from "../../components/ParadigmaTable/DateFilter";
import api from "../../api/api.js";
import moment from 'moment';

class Reservas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    accessor: d => moment(d.fecha).format('DD/MM/YYYY'),
                    className: "text-center",
                    show: true,
                    width: 100,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Cliente",
                    id: "cliente_nombre",
                    accessor: "cliente_nombre",
                    show: true,
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: "vendedor_nombre",
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo_nombre",
                    accessor: "loteo_nombre",
                    show: true,
                },
                {
                    Header: "Lote",
                    id: "lote_nombre",
                    accessor: "lote_nombre",
                    show: true,
                },
                {
                    Header: "Tiene Venta",
                    id: "tieneventa",
                    accessor: (d) => (d.tieneventa ? 'Si' : 'No'),
                    Filter: ({ filter, onChange }) => (
                        <ParadigmaAsyncSeeker
                            url={undefined}
                            optionDefault={[{id: 'True', nombre: 'Si'}, {id: 'False', nombre: 'No'}]}
                            value={filter ? filter.value : ""}
                            onChange={(data) =>
                                data
                                    ? onChange(data.id)
                                    : filter
                                    ? onChange("")
                                    : null
                            }
                        />
                    ),
                    show: true,
                },
                // Estas columnas se usan en el Modal Ventas para rellenar los
                // campos que ya fueron previamente cargados en la reserva.
                {
                    Header: "Vendedor Aux",
                    id: "vendedor",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Loteo Aux",
                    id: "loteo",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Lote Aux",
                    id: "lote",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Cliente Aux",
                    id: "cliente",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Moneda Aux",
                    id: "moneda",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Monto Aux",
                    id: "monto",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Seña Aux",
                    id: "seña",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Cantidad Cuotas Aux",
                    id: "cantidadCuotas",
                    accessor: "id",
                    show: false,
                    private: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: props => <Modal {...props} action="CREATE"/>,
                        permission: 'ventas_reservas_new',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="EDIT" />,
                        permission: 'ventas_reservas_edit',
                    },
                    {
                        detail: true,
                        component: props => <Modal {...props} action="DETAIL" />,
                        permission: 'ventas_reservas_detail',
                    },
                    {
                        edit: true,
                        component: props => <Modal {...props} action="DELETE" />,
                        permission: 'ventas_reservas_delete',
                    },
                    {
                        edit: true,
                        component: props => <ModalVentas {...props} action="RESERVAS" disabledReserva={true} />,
                        permission: 'ventas_ventas_new',
                    }
                ]}
                depth={2}
                apiUrl={api.ventas.reservas}
                columns={this.state.columns}
                exportUrl={api.ventas.reservas}
                title={"Reservas de Venta"}
            />
        );
    }
}

export default Reservas;



// WEBPACK FOOTER //
// ./src/views/Reservas/Reservas.js